import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IProFormaMapping } from '../../views/ProFormaUpload/types';

interface IParams {
    organizationUuid: string;
    dealTypeId: number;
}

const getProFormaMapping = async ({ organizationUuid, dealTypeId }: IParams): Promise<IProFormaMapping> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.EXCEL_MAPPING(organizationUuid)}?dealTypeId=${dealTypeId}`);
    return response.data;
};

const useGetProFormaMapping = (organizationUuid: string, dealTypeId: number, options?: any) => useQuery<IProFormaMapping>({
    queryKey: ['ProFormaMapping', organizationUuid, dealTypeId],
    queryFn: () => getProFormaMapping({ organizationUuid, dealTypeId }),
    ...options,
});

export default useGetProFormaMapping;
